import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Tag, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { departmentAdminApi, departmentApi } from '../../services/api';

const DepartmentAccounts = () => {
  const navigate = useCompanyNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [departments, setDepartments] = useState([]);

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const res = await departmentAdminApi.list({ page, limit: pagination.pageSize });
      if (res.success) {
        setData(res.data.list);
        setPagination({ ...pagination, current: page, total: res.data.pagination.total });
      }
    } catch (error) {
      message.error('获取列表失败');
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await departmentApi.all();
      setDepartments(res.data);
    } catch (err) {}
  };

  useEffect(() => {
    fetchData();
    fetchDepartments();
  }, []);

  const handleDelete = async (id) => {
    try {
      await departmentAdminApi.delete(id);
      message.success('删除成功');
      fetchData(pagination.current);
    } catch (error) {
      message.error('删除失败');
    }
  };

  const getDeptName = (deptId) => {
    const dept = departments.find(d => d.id === deptId);
    return dept ? dept.name : '-';
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '用户名', dataIndex: 'username' },
    { title: '姓名', dataIndex: 'real_name' },
    { title: '部门', dataIndex: 'department_id', render: (id) => getDeptName(id) },
    { title: '手机号', dataIndex: 'phone' },
    {
      title: '状态',
      dataIndex: 'is_active',
      render: (v) => <Tag color={v === 1 ? 'green' : 'red'}>{v === 1 ? '启用' : '禁用'}</Tag>
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => navigate(`/admin/department-accounts/${record.id}/edit`)}>
            编辑
          </Button>
          <Popconfirm title="确定删除该账号吗？" onConfirm={() => handleDelete(record.id)}>
            <Button type="link" danger icon={<DeleteOutlined />}>删除</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <Button icon={<ReloadOutlined />} onClick={() => fetchData(pagination.current)}>刷新</Button>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/admin/department-accounts/new')}>
          新增账号
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        pagination={{ ...pagination, onChange: (page) => fetchData(page) }}
      />
    </div>
  );
};

export default DepartmentAccounts;
